'use client'

import React from 'react'

type Props = {
    diagonalP: number
    diagonalQ: number
    sideA: number
    sideB: number
}

const WIDTH = 340
const HEIGHT = 220

export default function KiteChart({ diagonalP, diagonalQ, sideA, sideB }: Props) {
    const maxDim = Math.max(diagonalP, diagonalQ, 0.0001)
    const scale = 160 / maxDim
    const p = Math.max(diagonalP * scale, 30) // horizontal diagonal
    const q = Math.max(diagonalQ * scale, 30) // vertical diagonal

    const cx = WIDTH / 2
    // Kites aren't symmetric about the horizontal diagonal's midpoint - split
    // the vertical diagonal unevenly for a visually distinct (non-rhombus) shape
    const cy = HEIGHT / 2 - q * 0.1

    const A = [cx, cy - q * 0.55]
    const B = [cx + p / 2, cy]
    const C = [cx, cy + q * 0.45]
    const D = [cx - p / 2, cy]

    return (
        <svg width={WIDTH} height={HEIGHT} viewBox={`0 0 ${WIDTH} ${HEIGHT}`} style={{ maxWidth: '100%', height: 'auto' }}>
            <polygon points={`${A.join(',')} ${B.join(',')} ${C.join(',')} ${D.join(',')}`} fill="#2563eb" opacity={0.18} stroke="#2563eb" strokeWidth={2} />
            <line x1={D[0]} y1={D[1]} x2={B[0]} y2={B[1]} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <line x1={A[0]} y1={A[1]} x2={C[0]} y2={C[1]} stroke="#9ca3af" strokeWidth={1.5} strokeDasharray="4,3" />
            <text x={(D[0] + B[0]) / 2} y={cy - 8} fontSize={12} textAnchor="middle" fill="#374151">p = {diagonalP.toFixed(2)}</text>
            <text x={cx + 12} y={(A[1] + C[1]) / 2} fontSize={12} textAnchor="start" fill="#374151">q = {diagonalQ.toFixed(2)}</text>
            <text x={(A[0] + B[0]) / 2 + 20} y={(A[1] + B[1]) / 2} fontSize={12} textAnchor="middle" fill="#374151">a = {sideA.toFixed(2)}</text>
            <text x={(B[0] + C[0]) / 2 + 20} y={(B[1] + C[1]) / 2} fontSize={12} textAnchor="middle" fill="#374151">b = {sideB.toFixed(2)}</text>
        </svg>
    )
}
